var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollaspLeft = function SvgCollaspLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#868E96",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m7.333 4-2.8 3.36c-.255.306-.382.459-.382.64s.127.334.383.64l2.8 3.36M12 4 9.2 7.36c-.255.306-.382.459-.382.64s.127.334.382.64L12 12"
  })));
};
export default SvgCollaspLeft;